import Dexie from "dexie";
import { Injectable } from "@angular/core";
import { Event } from "../entity/Event";
import { Ticket } from "../entity/Ticket";
import { PromotionCode } from "@smartnowx/hcms-plugin-event-manager";

const DATABASE_NAME: string = "offline-db";

@Injectable({
    providedIn: 'root'
  })
export class OfflineDatabase extends Dexie {

    public events: Dexie.Table<Event,number>
    public tickets: Dexie.Table<Ticket,string>
    public promotion_codes: Dexie.Table<PromotionCode,number>;

    public constructor() {
        super(DATABASE_NAME);
        this.version(1.2).stores({
            events: "++id",
            tickets: "++validity_token, id, laravel_through_key, ticket_type.event_id",
            promotion_codes: "++id, event_id, code"
        });

        this.events = this.table("events");
        this.tickets = this.table("tickets");
        this.promotion_codes = this.table("promotion_codes");

        this.on('populate', () => this.migrate());

        // this.tickets.mapToClass(Ticket);
    }

    async migrate(){
        await this.events.bulkAdd([] as Event[]);
        await this.tickets.bulkAdd([] as Ticket[]);
        await this.promotion_codes.bulkAdd([] as PromotionCode[]);
    }

    public deleteDatabase(){
        var req = indexedDB.deleteDatabase(DATABASE_NAME);
        req.onsuccess = function () {
            console.log("Deleted database successfully");
        };
        req.onerror = function () {
            console.log("Couldn't delete database");
        };
        req.onblocked = function () {
            console.log("Couldn't delete database due to the operation being blocked");
        };
    }

}